import { useEffect, useState } from 'react'
import { Box } from '~/design_system'
import { VirtualizedList } from './VirtualizedList'
import { List } from './List'

const defaultConfig = {
  visibleItemCount: 10,
  itemSize: 40,
  isVirtualized: false,
  maxCheckableCount: 0
}

/** @param {{ options: any, onChange: any, value: any, config?: any, onItemsRendered?: any, ref?: any }} props */
export function CheckboxList({ options, onChange, value, config: checkboxConfig, onItemsRendered, ref }) {
  const {
    visibleItemCount,
    maxCheckableCount,
    itemSize,
    isVirtualized,
    containerMaxHeight = '400px'
  } = {
    ...defaultConfig,
    ...checkboxConfig
  }
  const [checkedValues, setCheckedValues] = useState([])
  const [checkedItems, setCheckedItems] = useState([])
  const [indexedOptions, setIndexedOptions] = useState([])
  useEffect(() => {
    /*
      eslint-disable-next-line react-hooks/set-state-in-effect --

      ⚠️ HEY YOU, DEV! Yes, YOU! Don't you look away...I know you are reading this. This is your problem now.
      Fix the below while you are working in here. It's simple, just delete this comment, and you'll see the lint error.
      There's even a suggestion on how you might fix it. These particular lint errors are serious issues that we
      couldn't feasibly fix across the whole codebase, but they need fixed. Your help is appreciated! 🥳

      Issue: Syncing indexedOptions/checkedValues from props causes cascading renders.
      Possible fix approach: Compute inline instead of state. memoization can be handled manually if needed:
        // Remove: const [indexedOptions, setIndexedOptions] = useState([])
        // Remove: this useEffect
        const indexedOptions = options?.map((option, index) => ({ ...option, index })) || []
        const checkedValues = value?.map(String) ?? []
        const checkedItems = indexedOptions.map(option => checkedValues.includes(option?.value?.toString()))
    */
    setIndexedOptions(options?.map((option, index) => ({ ...option, index })))
    setCheckedValues(value?.map(String) ?? [])
  }, [value])

  useEffect(() => {
    const updatedIndexedOptions = options?.map((option, index) => ({ ...option, index }))
    /*
      eslint-disable-next-line react-hooks/set-state-in-effect --

      ⚠️ HEY YOU, DEV! Yes, YOU! Don't you look away...I know you are reading this. This is your problem now.
      Fix the below while you are working in here. It's simple, just delete this comment, and you'll see the lint error.
      There's even a suggestion on how you might fix it. These particular lint errors are serious issues that we
      couldn't feasibly fix across the whole codebase, but they need fixed. Your help is appreciated! 🥳

      Issue: Deriving indexedOptions/checkedItems from options and checkedValues causes cascading renders.
      Possible fix approach: Remove intermediate state and compute inline. memoization can be handled manually if needed:
        // This entire effect can be removed - see the first useEffect comment for the combined fix
        const checkedItems = indexedOptions.map(option => checkedValues.includes(option?.value?.toString()))
    */
    setIndexedOptions(updatedIndexedOptions)
    const updatedCheckedItems = updatedIndexedOptions.map(option => checkedValues.includes(option?.value?.toString()))
    setCheckedItems(updatedCheckedItems)
  }, [options, checkedValues])

  const shouldDisableCheckbox = () => {
    if (maxCheckableCount <= 0) return false
    return checkedValues.length >= maxCheckableCount
  }

  const onOptionsChange = e => {
    if (!e.target.value || e.target.value === '') return
    let combinedValues = []
    const updatedValue = e.target.value
    if (e.target.checked) {
      combinedValues = [...new Set([...checkedValues, updatedValue])]
    } else {
      combinedValues = checkedValues.filter(value => value !== updatedValue)
    }
    setCheckedValues(combinedValues)
    onChange(combinedValues)
  }
  const itemCount = indexedOptions?.length > visibleItemCount ? visibleItemCount : indexedOptions?.length
  return (
    <Box mt={-2} mx={-4} mb={-5} py={2} pl={4} pr={2} data-testid="cb-list">
      {isVirtualized ? (
        <VirtualizedList
          onItemsRendered={onItemsRendered}
          ref={ref}
          height={itemCount * itemSize}
          itemCount={indexedOptions.length}
          itemSize={() => itemSize}
          options={indexedOptions}
          checkedItems={checkedItems}
          onChange={onOptionsChange}
          isDisabled={shouldDisableCheckbox()}
        />
      ) : (
        <List
          ref={ref}
          maxH={containerMaxHeight}
          overflowY="auto"
          options={indexedOptions}
          checkedItems={checkedItems}
          onChange={onOptionsChange}
          isDisabled={shouldDisableCheckbox()}
          onItemsRendered={onItemsRendered}
        />
      )}
    </Box>
  )
}

CheckboxList.displayName = 'CheckboxList'
